import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col, Card, Button, Modal, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Select from "react-select";
import { getUserList } from "../../api/userService";
import {getNotifications, getNotificationDetails, sendNotification, destroyNotification } from "../../api/notificationService";
export default function Notifications() {
  const [notifications, setNotifications] = useState([]);

  const [totalNotifications, setTotalNotifications] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [sent, setSent] = useState(false);
  const [Viewdetail, setViewdetail] = useState(false);
  const [loading, setLoading] = useState(false); // Add this state for loading
  const senttoggle = () => setSent(!sent);
  const viewtoggle = () => setViewdetail(!Viewdetail);
  const [selectuserValue, setSelectuserValue] = useState([]);
  const [users, setUsers] = useState([]);
  const [messageContent, setMessageContent] = useState("");
  const [notificationDetails, setNotificationDetails] = useState(null);

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    if (sent) {
      fetchUsers();
    }
  }, [sent]);



  const fetchNotifications = (page = 1, size = 10) => {
    setLoading(true);
    getNotifications({ page, pageSize: size })
      .then((response) => {
        setNotifications(response.data);
        // setTotalNotifications(response.data.pagination.totalNotifications || 0);
      })
      .catch((error) => console.error("Error fetching notifications", error))
      .finally(() => setLoading(false));
  };

  const fetchUsers = () => {
    getUserList()
      .then((response) => {
        if (response.data) {
          const userOptions = response.data.map((user) => ({
            value: user._id,
            label: user.fullName || user.username,
            isFixed: false,
          }));
          userOptions.unshift({ value: "all", label: "Select All Users" }); // Add "Select All Users" at the top
          setUsers(userOptions);
        }
      })
      .catch((error) => console.error("Error fetching users list", error));
  };

  const handleDeleteNotification = () => {
    if (!notificationToDelete) return; // If no notification is selected for deletion, exit

      destroyNotification({notificationId: notificationToDelete})
      .then((response) => {
        if (response.data) {
          // Remove the deleted notification from the notifications array
          fetchNotifications(currentPage, pageSize);
          setShow(false); // Close the modal
          setNotificationToDelete(null); // Reset the notification to delete
        }
      })
      .catch((error) => {
        console.error("Error deleting notification", error);
        alert("Failed to delete notification. Please try again.");
      });
  };

  const handleShowDeleteModal = (id) => {
    setNotificationToDelete(id); // Set the tale ID to delete
    setShow(true); // Show the confirmation modal
  };

  const sendMessage = () => {
    const selectedUserIds = selectuserValue.map((user) => ({
      userId: user.value,
    }));
    const title = messageContent;
       sendNotification({title, receivers: selectedUserIds})
      .then((response) => {
        setSent(false); // Close modal on success
        setMessageContent("");
        fetchNotifications();
      })
      .catch((error) => console.error("Error sending message", error));
  };

  const handleViewDetails = (parentId) => {
      getNotificationDetails(parentId)
        .then((response) => {
          if (response.data) {
            setNotificationDetails(response.data[0]); // Set the fetched notification details
            setViewdetail(true);
        }
      })
      .catch((error) =>
        console.error("Error fetching notification details", error)
      );
  };

  const SelectuserOnChange = (value, { action, removedValue }) => {
    if (
      action === "select-option" &&
      value[value.length - 1]?.value === "all"
    ) {
      setSelectuserValue(users.filter((option) => option.value !== "all")); // Select all users except "all"
    } else if (action === "deselect-option" && removedValue.value === "all") {
      setSelectuserValue([]);
    } else if (
      action === "deselect-option" &&
      selectuserValue.length === users.length - 1
    ) {
      setSelectuserValue(value.filter((option) => option.value !== "all")); // Remove "Select All" if unselecting after selecting all
    } else {
      setSelectuserValue(value);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid #DADADA" : "1px solid #DADADA",
      boxShadow: "none",
      minHeight: "52px",
      fontSize: "14px",
      borderRadius: "8px",
      "&:hover": {
        border: "1px solid #DADADA",
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      color: "#fff",
      backgroundColor: "#3895F3",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#fff",
    }),
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "sent":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchNotifications(page, pageSize); // Fetch data for the new page
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1); // Reset to first page
    fetchNotifications(1, newPageSize); // Fetch data with new page size
  };

  const columns = [
    {
      name: "Sr.No.",
      width: "110px",
      selector: (row) => row.SrNo,
      sortable: true,
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1, // Calculate Sr.No. based on page and index
    },
    {
      name: "Name", // New column for toId names
      width: "250px",
      selector: (row) => row.toId.fullName,
      sortable: true,
      cell: (row) => row.toId.fullName, // Display aggregated toId names
    },
    {
      name: "Message",
      width: "230px",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => row.title,
    },
    {
      name: "Date",
      width: "180px",
      selector: (row) => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
    {
      name: "Status",
      width: "150px",
      selector: (row) => row.clearStatus,
      sortable: true,
      cell: (row) => (
        <span style={getStatusStyle(row.status)}>{row.status}</span>
      ),
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <>
          <Link
            className="btnview"
            onClick={() => handleViewDetails(row._id)}
          >
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link
            className="btndelete"
            onClick={() => handleShowDeleteModal(row._id)}
          >
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];

  const filteredData = notifications.filter(
    (item) =>
      (item.title &&
        item.title.toLowerCase().includes(searchText.toLowerCase())) ||
      (item.content &&
        item.content.toLowerCase().includes(searchText.toLowerCase())) ||
      item.recievers.some((receiver) =>
        receiver.userId?.fullName
          .toLowerCase()
          .includes(searchText.toLowerCase())
      )
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
              <h5>Notifications</h5>
              <Button
                className="btn btn-primary-light px-4 min_width140"
                onClick={senttoggle}
              >
                Send
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                className="custom-table"
                progressPending={loading}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleRowsPerPageChange}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary px-4 min_width110"
            onClick={handleDeleteNotification}
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>

      {/* Send Message Modal */}
      <Modal show={sent} onHide={senttoggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-4">
            <Select
              placeholder="Select User"
              styles={customStyles}
              isMulti
              options={users}
              onChange={SelectuserOnChange}
              value={selectuserValue}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={messageContent}
              onChange={(e) => setMessageContent(e.target.value)}
            />
          </Form.Group>
          <div className="text-end">
            <Button
              className="btn btn-primary-light me-3 px-4 min_width130"
              onClick={senttoggle}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary px-4 min_width130"
              onClick={sendMessage}
            >
              Send
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="modal_notification"
        show={Viewdetail}
        onHide={viewtoggle}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Notification Details</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {notificationDetails ? (
            <div className="notificationdtl_list">
              <div className="notificationdtl_grid">
                <h4>Name</h4>
                <p>
                  {notificationDetails.toId.fullName || "N/A"}
                </p>
              </div>
              <div className="notificationdtl_grid">
                <h4>Message</h4>
                <p>
                  {notificationDetails.title || "N/A"}
                </p>
              </div>
              <div className="notificationdtl_grid">
                <h4>Date</h4>
                <p>
                  {new Date(
                    notificationDetails.createdAt
                  ).toLocaleDateString() || "N/A"}
                </p>
              </div>
              <div className="notificationdtl_grid">
                <h4>Status</h4>
                <span style={getStatusStyle(notificationDetails.status)}>
                  {notificationDetails.status || "N/A"}
                </span>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
